import type { ViewfinderFrameAsset } from '@photobooth/shared';

/**
 * Pick the viewfinder frame whose aspect ratio is closest to the current
 * canvas aspect. Returns null when the manifest has no frames.
 */
export function pickFrameForCanvas(
  frames: readonly ViewfinderFrameAsset[],
  canvasWidth: number,
  canvasHeight: number,
): ViewfinderFrameAsset | null {
  if (frames.length === 0) return null;
  if (canvasWidth <= 0 || canvasHeight <= 0) return frames[0]!;
  const target = canvasWidth / canvasHeight;
  let best = frames[0]!;
  let bestDelta = Math.abs(best.width / best.height - target);
  for (let i = 1; i < frames.length; i++) {
    const f = frames[i]!;
    const d = Math.abs(f.width / f.height - target);
    if (d < bestDelta) {
      best = f;
      bestDelta = d;
    }
  }
  return best;
}
